// Wave 20.47 — cheer picker (the row of branded reaction buttons
// on the replay page). Tap one → fires onCheer(key) so the parent
// can POST to the server AND spawn the local animation.

import React from 'react';
import { Box, Stack, Tooltip, IconButton } from '@mui/material';
import { CHEER_PALETTE } from './cheerPalette';

interface Props {
  onCheer: (emojiKey: string) => void;
  disabled?: boolean;
}

export default function CheerBar({ onCheer, disabled }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 1,
        py: 0.5,
        borderRadius: 999,
        backgroundColor: 'rgba(15,15,20,0.85)',
        border: '1px solid rgba(255,255,255,0.1)',
        backdropFilter: 'blur(8px)',
      }}
    >
      <Stack direction="row" spacing={0.5}>
        {CHEER_PALETTE.map((c) => (
          <Tooltip key={c.key} title={c.label} placement="top" arrow>
            <IconButton
              onClick={() => onCheer(c.key)}
              disabled={disabled}
              size="medium"
              sx={{
                width: 44,
                height: 44,
                '&:hover': { transform: 'scale(1.15)', backgroundColor: 'transparent' },
                transition: 'transform 120ms ease-out',
              }}
            >
              <c.Glyph size={26} color={c.color} />
            </IconButton>
          </Tooltip>
        ))}
      </Stack>
    </Box>
  );
}
